import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  all: {
    id: 'components.aggregations.all',
    defaultMessage: 'All'
  },
  articles: {
    id: 'components.aggregations.articles',
    defaultMessage: 'Articles'
  },
  'article-archive': {
    id: 'components.aggregations.articles',
    defaultMessage: 'Articles'
  },
  events: {
    id: 'components.aggregations.events',
    defaultMessage: 'Events'
  },
  competitions: {
    id: 'components.aggregations.competitions',
    defaultMessage: 'Competitions'
  },
  projects: {
    id: 'components.aggregations.projects',
    defaultMessage: 'Projects'
  },
  products: {
    id: 'components.aggregations.products',
    defaultMessage: 'Products & BIM'
  },
  companies: {
    id: 'components.aggregations.companies',
    defaultMessage: 'Manufacturers'
  },
  folders: {
    id: 'components.aggregations.folders',
    defaultMessage: 'Folders'
  },
  users: {
    id: 'components.aggregations.users',
    defaultMessage: 'Users'
  },
  images: {
    id: 'components.aggregations.medias',
    defaultMessage: 'Images'
  },
  professionals: {
    id: 'components.aggregations.professionals',
    defaultMessage: 'Professionals'
  }
})
